import { LocationDescriptorObject } from 'history'
import { Store } from 'redux'
import { browserHistory } from 'react-router'
import React from 'react'

import { withQueryAndScope } from '../urlGenerators'

type GotoFunction = (url: string) => null
type StateFunction = (location: LocationDescriptorObject) => null
type ContextType = {
  goto: GotoFunction
  replace: GotoFunction
  gotoState: StateFunction
}
export const GotoContext = React.createContext<ContextType>({
  goto: () => null,
  replace: () => null,
  gotoState: () => null,
})

type Props = {
  history?: typeof browserHistory
  store: Store<State>
}
export default function GotoProvider({ history, store, children }: React.PropsWithChildren<Props>): React.ReactElement {
  const goto = (url: string) => {
    if (history) {
      history.push(withQueryAndScope(url, store.getState().get('location')))
    }

    return null
  }
  const gotoState: StateFunction = (location) => {
    if (history) {
      history.push(location)
    }
    return null
  }
  const replace = (url: string) => {
    if (history) {
      history.replace(withQueryAndScope(url, store.getState().get('location')))
    }

    return null
  }
  return <GotoContext.Provider value={{ goto, gotoState, replace }}>{children}</GotoContext.Provider>
}
